// extracted by mini-css-extract-plugin
export default {"root":"VanImageModal_root__uSS1-","img-container":"VanImageModal_img-container__RRx4C","edit-temp":"VanImageModal_edit-temp__gAx3j","btns":"VanImageModal_btns__zOyOm"};